<template>
  <g><path d="M15 13H30.4375V37.125H15C12.7909 37.125 11 35.3341 11 33.125V17C11 14.7909 12.7909 13 15 13Z" fill="white" stroke="currentColor" stroke-width="4" /><path d="M29.3125 11H35.8125C39.1262 11 41.8125 13.6863 41.8125 17V33.125C41.8125 36.4387 39.1262 39.125 35.8125 39.125H29.3125V11Z" fill="currentColor" /></g>
</template>
